import http from "@/services/http";

const signDocument = (params) => http.post('generate-pdf', params)

export default {
  signDocument,
}
